import { useMemo } from "react";

export function throttle<T extends (...args: any[]) => any>(
    fn: T,
    ms: number,
    { leading = true }: { leading?: boolean } = {},
): T {
    let lastCall = 0;
    let timeout: ReturnType<typeof setTimeout> | null = null;

    return ((...args: any[]) => {
        const now = Date.now();
        const remaining = ms - (now - lastCall);

        if (remaining <= 0 || (leading && lastCall === 0)) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            lastCall = now;
            fn(...args);
        } else if (!timeout) {
            timeout = setTimeout(() => {
                lastCall = Date.now();
                timeout = null;
                fn(...args);
            }, remaining);
        }
    }) as unknown as T;
}

export const useThrottled = <T extends (...args: any) => any>(fn: T, ms = 300): T => {
    return useMemo(() => throttle(fn, ms, { leading: false }), [fn, ms]) as unknown as T;
};
